export const validateImage = (img: string) => {
  if (img === null || img === '') {
    return 'assets/images/no-image.png';
  } else {
    return img;
  }
};
